import $ from "jquery";

if (document.querySelector(".sliderNosotros_slider")) {

    const cardSliderCards = document.querySelectorAll(".sliderNosotros_slider");

    cardSliderCards.forEach(cardSlider => {
        const slickSlider = $(cardSlider).slick({
            dots: true,
            autoplay: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
        });

        slickSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            const currentSlideTitleHTML = $(slick.$slides[nextSlide]).find('.sliderNosotros_sliderItem--title').html();
            $('#slideNosotrosTitle').fadeOut(500, function() {
                $(this).html(currentSlideTitleHTML).fadeIn(500);
            });
        });
    });
}
